import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { RadioDropdown } from '@saucelabs/sl-component-form';

const DesktopBrowserConfiguratorTunnel = ({ tunnels }) => {
  const etiquette = 'Select tunnel';
  const emptyTunnel = {
    text: etiquette,
    value: '-1',
  };
  const prepareItem = (item) => ({
    key: item.get('id'),
    text: item.getName(),
    value: item.getIdentifier(),
    disabled: item.get('status') !== 'running',
  });
  const options = tunnels.map(prepareItem);

  if (options.length) {
    options.unshift(emptyTunnel);
  }

  return (
    <Field
      component={RadioDropdown}
      disabled={!options.length}
      etiquette={options.length ? etiquette : 'No Active Tunnels'}
      isInputForm
      label="Sauce Connect Proxy"
      name="tunnel"
      normalize={(value) => (value === emptyTunnel.value ? null : value)}
      options={options}
      showOptional
      type="input"
    />
  );
};

DesktopBrowserConfiguratorTunnel.propTypes = {
  tunnels: PropTypes.array.isRequired,
};

export default DesktopBrowserConfiguratorTunnel;
